import script from "./EmailCollectorInput.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailCollectorInput.vue?vue&type=script&setup=true&lang=js"

import "./EmailCollectorInput.vue?vue&type=style&index=0&id=89e1baec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89e1baec"]])

export default __exports__